import React from "react";
import HemaLogo from "../assets/images/HematogenixRed.svg";
import NewPassword from "../components/Onboarding";
import AuthResetPassword from "../components/auth/authResetPassword";

const SetNewPassword = () => {
  return (
    <div className="flex w-full">
      <AuthResetPassword bg />
      <div className="px-7 lg:pl-[130px]  lg:pb-[248px] w-full lg:w-[50%] min-h-screen bg-hemaSecondary">
        <div className="mt-8 lg:mt-[60px] mb-[62px] lg:mb-[104px]">
          <img src={HemaLogo} alt="Company logo" />
        </div>
        <NewPassword />
      </div>
    </div>
  );
};

export default SetNewPassword;
